<template>
  <div>
    <alert :errors="errors" css_class="ma-1"></alert>
    <list-table
      class="mt-12"
      :itemList="itemList"
      :canAddCategory="canAddCategory"
      @on-delete-category="onDeleteCategory"
      @on-attach-permission="onAttachPermission"
    ></list-table>
  </div>
</template>

<script>
import ListTable from "../components/pref-categorymail-edits/list-table.vue";
import Alert from "../components/common/alert.vue";
import AlertBuilder from "../logic/common/alert-contents";
import Api from "@/logic/api/api.js";
import valueMapper from "../logic/common/value-mapper";
export default {
  components: {
    "list-table": ListTable,
    alert: Alert,
  },
  computed: {
    itemList() {
      return this.$store.getters.managePrefCategoryMailSettingList;
    },
  },
  data() {
    this.$nextTick(() => {
      this.reloadData();
    });
    return {
      errors: [],
      canAddCategory: false,
    };
  },
  methods: {
    /**
     * 分類を一覧で取得する
     */
    reloadData() {
      this.$store.commit("setWaiting", true);

      const apiRequests = [];
      const processList = [];

      // 分類を取得する
      apiRequests.push("category.list");
      processList.push(
        Api.call("/admin/hiroshima/information/category", {})
      );

      // メール通知設定を取得する
      apiRequests.push("mailSetting.list");
      processList.push(
        Api.call("/admin/hiroshima/email/notification/setting", {})
      );

      Promise.all(processList)
        .then((result) => {
          this.$store.commit("setWaiting", false);
          //APIから取得した結果を画面に表示する
          let mailSettingList = [];
          if (apiRequests.includes("mailSetting.list")) {
            mailSettingList = result[apiRequests.indexOf("mailSetting.list")].settings;
          }

          this.$store.commit(
              "setManagePrefCategoryMailSettingList",
              mailSettingList.map((setting) => {
                return {
                  categoryId: setting.category_id,
                  category: setting.category,
                  mailSetting: setting.status,
                  mailSettingEdit: {
                    editable: true,
                  },
              };
            })
          );
        })
        .catch((result) => {
          this.$store.commit("setWaiting", false);
          Api.resolve(result);
        });
    },
    /**
     * メッセージをクリアする
     */
    clearMessage() {
      this.errors = [];
    },
    /**
     * 分類を削除する
     */
    onDeleteCategory(selected) {
      const deletedMap = {};
      // 送信パラメータを作成する
      const postData = {
        record_id: selected[0].recordId
      };
      this.clearMessage();
      this.$nextTick(() => {
        // 分類を削除する
        this.$store.commit("setWaiting", true);
        Api.call("/admin/hiroshima/information/category/delete", postData)
          .then((result) => {
            this.$store.commit("setWaiting", false);
            const message = valueMapper
              .map({
                success: AlertBuilder.success("削除しました"),
                failed: AlertBuilder.error("削除に失敗しました"),
              })
              .get(result.message);
            if (message) {
              this.errors.push(message);
            }
            if (result.failed) {
              result.failed.forEach((info) => {
                this.errors.push(
                  AlertBuilder.error(
                    `[${deletedMap[info.uid]}]:${info.reason.jp}`
                  )
                );
              });
            }
            this.reloadData();
          })
          .catch((result) => {
            this.$store.commit("setWaiting", false);
            Api.resolve(result);
          });
      });
    },
  },
};
</script>

<style></style>
